import React, {Component} from 'react';
import './styles/inputs.css';
import './styles/error-message.css';

class SetPasswordForm extends Component {
  /**
   * State
   */
  state = {
    isLoading: false,
    validationError: ''
  }

  /**
   * Handles the <form /> submit event
   */
  handleSubmit = (evt) => {
    evt.preventDefault();
    let validationError = '';

    // Put the component in loading state
    this.setState({isLoading: true});

    // Validates the password entered
    if(this.props.password !== this.props.password_2) {
      validationError = 'Both passwords must match';
    } else if (this.props.password.length < 6) {
      validationError = 'Password must be at least 6 characters long';
    }

    // Checks if there was an error
    this.setState({ validationError });
    if (validationError !== '' ) {
      this.setState({ isLoading: false });
      return false;
    }

    this.props.handleSubmit();

    return false;
  }

  /**
   * Rendering
   */
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="error-message" style={{
          display: this.state.validationError === '' ? 'none' : 'block'
        }}>
          {this.state.validationError}
        </div>

        <div className="inputs">
          <div className="inputs__field-wrap">
            <input className="inputs__input" type="password" placeholder="Enter Password"
              value={this.props.password}
              onChange={this.props.handlePasswordEdits}
            />
          </div>
          <div className="inputs__field-wrap">
            <input className="inputs__input" type="password" placeholder="Enter Password Again"
              value={this.props.password_2}
              onChange={this.props.handlePassword2Edits}
            />
          </div>
        </div>

        <div>
          <button className="submit-password button"  disabled={this.state.isLoading}>
            <div className='submitText'>{this.state.isLoading ? 'Loading...' : 'Set Password'}</div><div
              className="loader"
              style={{
                display: this.state.isLoading ? 'block' : 'none'
              }} />
          </button>
        </div>
      </form>
    )
  }
}

export default SetPasswordForm



// WEBPACK FOOTER //
// ./src/set-password-form.js